export default __webpack_public_path__ + "style-osm-800-080d3acaaccf04ddd687b0190eab8dae.webp";